import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";

export default function NewsDetail() {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/news/${slug}`).then((r) => setN(r.data.news)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <PublicLayout>
        <div className="max-w-3xl mx-auto py-24 text-center px-4">
          <h1 className="font-display font-bold text-3xl">Article not found</h1>
          <Link to="/news" className="text-[#1E3A8A] mt-4 inline-block">← Back to news</Link>
        </div>
      </PublicLayout>
    );
  }
  if (!n) return <PublicLayout><div className="p-10 text-slate-500">Loading…</div></PublicLayout>;

  return (
    <PublicLayout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <Link to="/news" className="text-sm text-slate-500 hover:text-[#1E3A8A]">← All news</Link>
        <div className="section-label mt-4">
          {n.published_at ? new Date(n.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" }) : ""}
        </div>
        <h1 className="mt-2 font-display font-bold text-4xl text-[#0A192F] leading-tight" data-testid="news-detail-title">{n.title}</h1>
        {n.excerpt && <p className="mt-3 text-lg text-slate-600 leading-relaxed">{n.excerpt}</p>}
        {n.cover_image && (
          <img src={n.cover_image} alt={n.title} className="mt-6 w-full rounded-xl border border-slate-200" />
        )}
        <div
          className="prose prose-slate max-w-none mt-8 text-slate-700 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: n.body_html || "" }}
        />
      </article>
    </PublicLayout>
  );
}
